import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  isNoteTakingAIEnabled: Yup.boolean().required(),
  noteSummaryAIModel: Yup.string().when(
    'isNoteTakingAIEnabled',
    ([isNoteTakingAIEnabled], schema) =>
      isNoteTakingAIEnabled ? schema.required() : schema.notRequired()
  ),
  isMagicSuggestionEnabled: Yup.boolean().required(),
  magicSuggestionAIModel: Yup.string().when(
    'isMagicSuggestionEnabled',
    ([isMagicSuggestionEnabled], schema) =>
      isMagicSuggestionEnabled ? schema.required() : schema.notRequired()
  ),
});

export default validationSchema;
